import React, { useContext } from 'react';
import LazyLoad from 'react-lazyload';
import scheme from '../../static/js/scheme';
import ChangeTabContext from '../comps/CreateContext';
import { imgCrop } from '../../static/js/imgcrop';
import vm from '../../static/js/unit';
import Base from '../../base';



const tmpVideo = (opt) => {
  return <div className="athm-card">
    <a onClick={opt.handleClick} className="athm-card-full169" href={scheme.insidebrowser(opt[Base.source + 'Url'])}>
      <div className="athm-card-full169__caption">{opt.title}</div>
      <div className="athm-card-full169__assist">
        <LazyLoad once offset={100}>
          <img src={imgCrop(opt.picUrl, '720x0_0_q80_c43__')} alt="" />
        </LazyLoad>
        <i className="athm-iconpng athm-iconpng-player"></i>
        <div className="athm-card-full169__time">{vm.getSecond(opt.duration)}</div>
      </div>
      <div className="athm-card-unit-information">
        <div className="athm-card-unit-information__item athm-card-unit-information__item--right">{vm.getTimeAgo(opt.publish_time)}</div>
        <div className="athm-card-unit-information__assist">
          <span className="athm-card-unit-information__item">{vm.getGreatNumber(opt.vv) + '播放'}</span><i className="athm-card-unit-information__division">/</i><span className="athm-card-unit-information__item">{opt.author}</span>
        </div>
      </div>
    </a>
  </div>
}
const tmpImgs = (opt) => {
  opt.multi_images.length = 3;
  return <div className="athm-card">
    <a onClick={opt.handleClick} className="athm-card-album43" href={scheme.insidebrowser(opt[Base.source + 'Url'])}>
      <div className="athm-card-album43__caption">{opt.title}</div>
      <div className="athm-card-album43__album">
        {
          opt.multi_images.map((item, index) => {
            return <div className="athm-card-album43__assist" key={index}>
              <LazyLoad once offset={100}>
                <img src={imgCrop(item, '240x0_0_q80_c42__')} alt="" />
              </LazyLoad>
            </div>
          })
        }
      </div>
      <div className="athm-card-unit-information">
        <div className="athm-card-unit-information__item athm-card-unit-information__item--right">{vm.getTimeAgo(opt.publish_time)}</div>
        <div className="athm-card-unit-information__assist">
          <span className="athm-card-unit-information__item">{vm.getGreatNumber(opt.reply_count) + '评论'}</span><i className="athm-card-unit-information__division">/</i><span className="athm-card-unit-information__item">{opt.author}</span>
        </div>
      </div>
    </a>
  </div>
}
const tmpImgText = (opt) => {
  return <div className="athm-card">
    <a onClick={opt.handleClick} className="athm-card-thumb43" href={scheme.insidebrowser(opt[Base.source + 'Url'])}>
      <div className="athm-card-thumb43__assist">
        <LazyLoad once offset={100}>
          <img src={imgCrop(opt.picUrl, '240x0_0_q80_c42__')} alt="" />
        </LazyLoad>
      </div>
      <div className="athm-card-thumb43__caption">{opt.title}</div>
      <div className="athm-card-unit-information">
        <div className="athm-card-unit-information__item athm-card-unit-information__item--right">{vm.getTimeAgo(opt.publish_time)}</div>
        <div className="athm-card-unit-information__assist">
          <span className="athm-card-unit-information__item">{vm.getGreatNumber(opt.pv) + '观众'}</span><i className="athm-card-unit-information__division">/</i><span className="athm-card-unit-information__item">{opt.author}</span>
        </div>
      </div>
    </a>
  </div>
}
const tmpText = (opt) => {
  return <div className="athm-card">
  <a onClick={opt.handleClick} className="athm-card-textmold" href={scheme.insidebrowser(opt[Base.source + 'Url'])}>
    <div className="athm-card-textmold__caption">{opt.title}</div>
    <div className="athm-card-unit-information">
      <div className="athm-card-unit-information__item athm-card-unit-information__item--right">{vm.getTimeAgo(opt.publish_time)}</div>
      <div className="athm-card-unit-information__assist">
        <span className="athm-card-unit-information__item">{vm.getGreatNumber(opt.reply_count) + '评论'}</span><i className="athm-card-unit-information__division">/</i><span className="athm-card-unit-information__item">{opt.author}</span>
      </div>
    </div>
  </a>
</div>
}
const Card = ({data}) => {
  const {
    tabOption,
  } = useContext(ChangeTabContext);

  data.handleClick = () => {
    Base.tongji('carlist_feed', {
      position: tabOption.tab,
      series: tabOption.id,
      id: data.biz_id,
    });
  };
  
  return (
    data.video_source ? tmpVideo(data) : (data.multi_images.length > 2) ? tmpImgs(data) : data.picUrl ? tmpImgText(data) : tmpText(data)
  )
}

export default Card;